var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarteira(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 13.0001C52.9 13.3871 55.525 14.2601 57.484 16.2311C61 19.7681 61 25.4621 61 36.8471C61 48.2321 61 53.9261 57.484 57.4631C53.968 61.0001 48.313 61.0001 37 61.0001H25C13.687 61.0001 8.029 61.0001 4.516 57.4601C1 53.9291 1 48.2351 1 36.8501C1 25.4651 1 19.7711 4.516 16.2341C6.475 14.2601 9.1 13.3871 13 13.0001",
    stroke: "#468CB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5001 11.5C24.9761 13.018 28.9001 19 31.0001 19M31.0001 19C33.1001 19 37.0241 13.018 38.5001 11.5M31.0001 19V1M50.5241 37H50.4941M11.5241 37H11.4941M38.5001 37C38.5001 38.9891 37.71 40.8968 36.3034 42.3033C34.8969 43.7098 32.9893 44.5 31.0001 44.5C29.011 44.5 27.1034 43.7098 25.6968 42.3033C24.2903 40.8968 23.5001 38.9891 23.5001 37C23.5001 35.0109 24.2903 33.1032 25.6968 31.6967C27.1034 30.2902 29.011 29.5 31.0001 29.5C32.9893 29.5 34.8969 30.2902 36.3034 31.6967C37.71 33.1032 38.5001 35.0109 38.5001 37Z",
    stroke: "#468CB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarteira);
export default __webpack_public_path__ + "static/media/carteira.c8a5c0879b532cfba3823cb899eba851.svg";
export { ForwardRef as ReactComponent };